import { Injectable, inject } from '@angular/core';

import { FavIconService } from './favicon.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeDetectionService {
  private readonly faviconService = inject(FavIconService);

  init(): void {
    const prefersDark = globalThis.matchMedia('(prefers-color-scheme: dark)').matches;

    const faviconUrl = prefersDark ? 'assets/images/WhiteIcon.svg' : 'assets/images/OneORM_ICON.svg';
    this.faviconService.setFavicon(faviconUrl);
  }
}
